import type { InjectionKey, Ref } from "vue"
import type { Article } from "~/types/article"

export const keys = {
  currentArticle: Symbol("currentArticle") as InjectionKey<
    ComputedRef<Article>
  >,
  isDark: Symbol("isDark") as InjectionKey<ComputedRef<boolean>>,
  showVariantModal: Symbol("showVariantModal") as InjectionKey<Ref<boolean>>,
}
